if (window.Alpine) {
    initialiseRoleSwitcher();
} else {
    document.addEventListener('alpine:init', initialiseRoleSwitcher);
}

function initialiseRoleSwitcher() {
    window.Alpine.data('roleSwitcher', () => ({
        loading: null,
        activeRole: null,

        init() {
            this.activeRole = this.$root.querySelector('.role-switcher__item.active')?.querySelector('[data-role]')?.dataset.role;
        },

        switchRole(role) {
            if (this.loading || role === this.activeRole) return;
            this.loading = role;

            fetch('/switch-role', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({ role })
            })
            .then(response => {
                if (!response.ok) {
                    this.loading = false;
                    throw new Error('Network response was not ok');
                }
                return window.location.reload();
            })
        },

        nextRole() {
            const roles = this.$root.querySelectorAll('.role-switcher__item');
            const currentIndex = Array.from(roles).findIndex(item =>
                item.querySelector('[data-role]').dataset.role === this.activeRole
            );

            if (currentIndex === -1) return;

            const nextIndex = (currentIndex + 1) % roles.length;
            const nextRole = roles[nextIndex].querySelector('[data-role]').dataset.role;

            this.updateTabIndexes(roles, nextIndex);
            this.switchRole(nextRole);
        },

        previousRole() {
            const roles = this.$root.querySelectorAll('.role-switcher__item');
            const currentIndex = Array.from(roles).findIndex(item =>
                item.querySelector('[data-role]').dataset.role === this.activeRole
            );

            if (currentIndex === -1) return;

            const prevIndex = (currentIndex - 1 + roles.length) % roles.length;
            const prevRole = roles[prevIndex].querySelector('[data-role]').dataset.role;

            this.updateTabIndexes(roles, prevIndex);
            this.switchRole(prevRole);
        },

        updateTabIndexes(roles, activeIndex) {
            roles.forEach((item, index) => {
                const button = item.querySelector('button');
                button.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
            });
        }
    }));
}
